/**
 * 战斗界面面板
 * 显示敌人信息、战斗日志
 */

import type { CombatState } from '../engine/Combat';

export class CombatPanel {
  private container: HTMLElement;

  constructor(containerId: string) {
    const el = document.getElementById(containerId);
    if (!el) throw new Error(`Element #${containerId} not found`);
    this.container = el;
    this.container.className = 'panel';
    this.showEmpty();
  }

  /** 显示敌人信息 */
  showEnemy(state: CombatState): void {
    const hpPercent = state.enemyMaxHp > 0
      ? Math.max(0, (state.enemy.hp / state.enemyMaxHp) * 100)
      : 0;

    this.container.innerHTML = `
      <div class="panel-title">⚔️ 战斗</div>
      <div class="enemy-info">
        <div class="enemy-name">${escapeHtml(state.enemy.name)}</div>
        <div style="color:var(--text-secondary); font-size:0.85em; margin-bottom:6px;">
          HP: ${state.enemy.hp}/${state.enemyMaxHp} | 攻: ${state.enemy.attack} | 防: ${state.enemy.defense}
        </div>
        <div class="stat-bar" style="margin:0 auto; max-width:200px;">
          <div class="stat-bar-fill hp" style="width:${hpPercent}%"></div>
        </div>
      </div>
      <div class="combat-log">
        ${state.log.map((l) => `<div class="log-entry">${escapeHtml(l)}</div>`).join('')}
      </div>
    `;

    // 自动滚动到底部
    const logEl = this.container.querySelector('.combat-log');
    if (logEl) logEl.scrollTop = logEl.scrollHeight;
  }

  /** 显示空状态 */
  showEmpty(): void {
    this.container.innerHTML = `
      <div class="panel-title">⚔️ 战斗</div>
      <div class="combat-empty">
        🏔️ 天地广阔，等待你去探索...<br>
        <span style="font-size:0.85em;">点击「探索战斗」遇敌修炼</span>
      </div>
    `;
  }
}

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
